import { SetStateAction } from 'react'
import ModalWrapper from 'core/components/common/ModalWrapper'
import { ModalHeader } from 'core/components/common/ModalHeader'
import { ModalBody } from 'core/components/common/ModalBody'
import { useTranslation } from 'react-i18next'
import { IconSelector } from 'lauria/components/common/IconSelector'
import { IIconeService } from 'core/interfaces/Service'

export const IconSelectorModal: React.FC<{
  open: boolean
  setOpen: (value: SetStateAction<boolean>) => void
  handleClick: (icon: IIconeService) => void
  icon: IIconeService
}> = ({ open, setOpen, handleClick, icon }) => {
  const { t } = useTranslation()
  return (
    <ModalWrapper
      classNames={{ modal: 'modal modal-icon-selector' }}
      onClose={() => setOpen(false)}
      open={open}
      showCloseIcon={false}
    >
      <ModalHeader>{t('applications.form.iconSelector.title')}</ModalHeader>
      <ModalBody className="py-[20px] px-[30px] relative">
        <IconSelector
          handleSubmit={handleClick}
          handleCancel={() => setOpen(false)}
          icon={icon}
        />
      </ModalBody>
    </ModalWrapper>
  )
}
